export enum LiveChatNoteTypes {
  USER_THREAD_NOTE = 'user_thread_note',
  USER_THREAD_NOTE_SMS = 'user_thread_note_sms',
  USER_THREAD_NOTE_TELEGRAM = 'user_thread_note_telegram',
  USER_THREAD_NOTE_INSTAGRAM = 'user_thread_note_instagram',
  USER_THREAD_NOTE_WHATSAPP = 'user_thread_note_whatsapp',
  USER_THREAD_NOTE_TIKTOK = 'user_thread_note_tiktok',
}

export const UserThreadNoteSocketEvents = Object.values(LiveChatNoteTypes)
